module.exports = __webpack_public_path__ + "img/Solid_ColourIcons_1024px-31.25d4ecd4.svg";